(function () {
        var revealItems = Array.prototype.slice.call(document.querySelectorAll(".reveal"));
        var guideCards = Array.prototype.slice.call(document.querySelectorAll("[data-guide-card]"));
        var guideSections = Array.prototype.slice.call(document.querySelectorAll("[data-guide-section]"));
        var tabGroups = Array.prototype.slice.call(document.querySelectorAll("[data-tab-group]"));
        var portalFocusSteps = Array.prototype.slice.call(document.querySelectorAll(".portal-focus-step[data-portal-focus]"));
        var portalFocusTargets = Array.prototype.slice.call(document.querySelectorAll(".portal-region[data-portal-target]"));
        var portalFocusBadge = document.getElementById("portal-focus-badge");
        var portalFocusTitle = document.getElementById("portal-focus-title");
        var portalFocusText = document.getElementById("portal-focus-text");
        var portalFocusPoints = document.getElementById("portal-focus-points");

        function activateGuideCard(id) {
          guideCards.forEach(function (card) {
            card.classList.toggle("is-active", card.getAttribute("data-guide-card") === id);
          });
        }

        guideCards.forEach(function (card) {
          card.addEventListener("click", function (event) {
            var targetId = card.getAttribute("data-guide-card");
            var target = targetId ? document.getElementById(targetId) : null;
            if (!target) {
              return;
            }

            event.preventDefault();
            activateGuideCard(targetId);
            target.scrollIntoView({ behavior: "smooth", block: "start" });
          });
        });

        tabGroups.forEach(function (group) {
          var buttons = Array.prototype.slice.call(group.querySelectorAll("[data-tab-target]"));
          var panels = Array.prototype.slice.call(group.querySelectorAll("[data-tab-panel]"));

          function activateTab(target) {
            buttons.forEach(function (button) {
              var isActive = button.getAttribute("data-tab-target") === target;
              button.classList.toggle("is-active", isActive);
              button.setAttribute("aria-selected", isActive ? "true" : "false");
            });

            panels.forEach(function (panel) {
              panel.classList.toggle("is-active", panel.getAttribute("data-tab-panel") === target);
            });
          }

          buttons.forEach(function (button) {
            button.addEventListener("click", function () {
              activateTab(button.getAttribute("data-tab-target"));
            });
          });

          if (buttons.length) {
            activateTab(buttons[0].getAttribute("data-tab-target"));
          }
        });

        function activatePortalFocus(step) {
          if (!step || !portalFocusBadge || !portalFocusTitle || !portalFocusText || !portalFocusPoints) {
            return;
          }

          var focusId = step.getAttribute("data-portal-focus");
          var badge = step.getAttribute("data-badge") || "";
          var title = step.getAttribute("data-title") || "";
          var text = step.getAttribute("data-text") || "";
          var points = (step.getAttribute("data-points") || "").split("|").filter(Boolean);

          portalFocusSteps.forEach(function (item) {
            item.classList.toggle("is-active", item === step);
          });

          portalFocusTargets.forEach(function (target) {
            target.classList.toggle("is-active", target.getAttribute("data-portal-target") === focusId);
          });

          portalFocusBadge.textContent = badge;
          portalFocusTitle.textContent = title;
          portalFocusText.textContent = text;
          portalFocusPoints.innerHTML = points.map(function (point) {
            return "<li>" + point + "</li>";
          }).join("");
        }

        portalFocusSteps.forEach(function (step) {
          step.addEventListener("click", function () {
            activatePortalFocus(step);
          });

          step.addEventListener("mouseenter", function () {
            activatePortalFocus(step);
          });
        });

        if ("IntersectionObserver" in window) {
          var revealObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                revealObserver.unobserve(entry.target);
              }
            });
          }, { threshold: 0.18 });

          revealItems.forEach(function (item) {
            revealObserver.observe(item);
          });

          var guideObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                var sectionId = entry.target.getAttribute("id");
                activateGuideCard(sectionId);
              }
            });
          }, {
            threshold: 0.35,
            rootMargin: "-18% 0px -52% 0px"
          });

          guideSections.forEach(function (section) {
            guideObserver.observe(section);
          });

          if (portalFocusSteps.length) {
            var portalObserver = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  activatePortalFocus(entry.target);
                }
              });
            }, {
              threshold: 0.55,
              rootMargin: "-18% 0px -35% 0px"
            });

            portalFocusSteps.forEach(function (step) {
              portalObserver.observe(step);
            });
          }
        } else {
          revealItems.forEach(function (item) {
            item.classList.add("is-visible");
          });
        }

        if (guideCards.length) {
          activateGuideCard("que-es");
        }

        if (portalFocusSteps.length) {
          activatePortalFocus(portalFocusSteps[0]);
        }
      })();

(function () {
        var prices1yr = [
          [249, 449, 899],
          [399, 699, 1299],
          [699, 1199, 2199],
          [1199, 2099, 3699],
          [1999, 3699, 6999]
        ];

        var planNames = ["Básico", "Plus", "Pro"];
        var rangeOptionValues = ["4k-10k", "10k-20k", "20k-40k", "40k-70k", "70k-140k"];
        var planOptionValues = ["Básico", "Plus", "Pro"];
        var durationOptionValues = ["1 año", "2 años"];

        function loadVariants() {
          var payload = document.getElementById("cpc3-variants-data");
          if (!payload) {
            return [];
          }

          try {
            return JSON.parse(payload.textContent || "[]");
          } catch (error) {
            console.error("No se pudieron leer las variantes de Clikea Protect.", error);
            return [];
          }
        }

        var variants = loadVariants();
        var selRange = null;
        var selPlan = 1;
        var selDuration = 1;

        var rangeSelect = document.getElementById("cpc3-range");
        var planButtons = Array.prototype.slice.call(document.querySelectorAll("#cpc3-plans .cpc3__pill"));
        var durationButtons = Array.prototype.slice.call(document.querySelectorAll("#cpc3-durations .cpc3__dur-btn"));
        var empty = document.getElementById("cpc3-empty");
        var data = document.getElementById("cpc3-data");
        var form = document.getElementById("cpc3-form");
        var cartBtn = document.getElementById("cpc3-cart-btn");
        var variantInput = document.getElementById("cpc3-variant-id");

        if (!rangeSelect || !empty || !data || !form || !cartBtn || !variantInput) {
          return;
        }

        function fmt(value) {
          return Number(value || 0).toLocaleString("es-MX");
        }

        function findVariant() {
          if (selRange === null || selPlan === null || selDuration === null) {
            return null;
          }

          var rv = rangeOptionValues[selRange];
          var pv = planOptionValues[selPlan];
          var dv = durationOptionValues[selDuration - 1];

          return variants.find(function (variant) {
            var options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
            return options.indexOf(rv) !== -1 &&
              options.indexOf(pv) !== -1 &&
              options.indexOf(dv) !== -1;
          }) || null;
        }

        function animatePrice(element) {
          if (!element) {
            return;
          }
          element.style.animation = "none";
          element.offsetHeight;
          element.style.animation = "";
        }

        function updateCalculator() {
          if (selRange === null || selPlan === null || selDuration === null) {
            empty.style.display = "flex";
            data.style.display = "none";
            return;
          }

          empty.style.display = "none";
          data.style.display = "flex";

          var base = prices1yr[selRange][selPlan];
          document.getElementById("cpc3-plan-display").textContent = "Clikea Protect " + planNames[selPlan];
          document.getElementById("cpc3-coverage-display").textContent = selDuration === 1 ? "1 año" : "2 años";

          var oneYearBlock = document.getElementById("cpc3-price-1yr");
          var twoYearBlock = document.getElementById("cpc3-price-2yr");

          if (selDuration === 1) {
            oneYearBlock.style.display = "flex";
            twoYearBlock.style.display = "none";
            var oneYearPrice = document.getElementById("cpc3-price-val");
            oneYearPrice.textContent = "$" + fmt(base);
            animatePrice(oneYearPrice);
          } else {
            oneYearBlock.style.display = "none";
            twoYearBlock.style.display = "flex";
            var regular = base * 2;
            var discount = Math.round(regular * 0.20);
            var final = regular - discount;
            document.getElementById("cpc3-regular").textContent = "$" + fmt(regular);
            document.getElementById("cpc3-saving").textContent = "-$" + fmt(discount);
            var finalPrice = document.getElementById("cpc3-final");
            finalPrice.textContent = "$" + fmt(final);
            animatePrice(finalPrice);
          }

          var variant = findVariant();
          variantInput.value = variant ? variant.id : "";
          cartBtn.disabled = !variant;
        }

        rangeSelect.addEventListener("change", function () {
          selRange = this.value === "" ? null : parseInt(this.value, 10);
          updateCalculator();
        });

        planButtons.forEach(function (button) {
          button.addEventListener("click", function () {
            planButtons.forEach(function (item) {
              item.classList.remove("active");
            });
            this.classList.add("active");
            selPlan = parseInt(this.dataset.plan, 10);
            updateCalculator();
          });
        });

        durationButtons.forEach(function (button) {
          button.addEventListener("click", function () {
            durationButtons.forEach(function (item) {
              item.classList.remove("active");
            });
            this.classList.add("active");
            selDuration = parseInt(this.dataset.duration, 10);
            updateCalculator();
          });
        });

        form.addEventListener("submit", function (event) {
          event.preventDefault();
          var variantId = variantInput.value;
          if (!variantId) {
            return;
          }

          var originalLabel = cartBtn.innerHTML;
          cartBtn.disabled = true;
          cartBtn.innerHTML = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\"><polyline points=\"20 6 9 17 4 12\"></polyline></svg> Agregando";

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error("No se pudo agregar el plan al carrito.");
              }

              return response.json();
            })
            .then(function () {
              window.location.href = "/cart";
            })
            .catch(function (error) {
              console.error(error);
              cartBtn.disabled = false;
              cartBtn.innerHTML = originalLabel;
              window.alert("No se pudo agregar el plan al carrito. Revisa que el producto y sus variantes estén configurados correctamente en la sección.");
            });
        });

        if (durationButtons.length) {
          durationButtons.forEach(function (item) {
            item.classList.remove("active");
          });
          durationButtons[0].classList.add("active");
        }

        updateCalculator();
      })();
